import { groupInput, InputProvider } from "@redotech/ui/form";
import { memo } from "react";

// Amazon OAuth doesn't require any inputs
export const AmazonCarrierInput = groupInput({});

export type AmazonCarrierValue = InputProvider.Value<typeof AmazonCarrierInput>;

export type AmazonCarrierForm = InputProvider.Form<typeof AmazonCarrierInput>;

export const amazonCarrierDefault = (): AmazonCarrierValue => ({});

export const CreateAmazonCarrierForm = memo(function CreateAmazonCarrierForm({
  carrierInput,
}: {
  carrierInput: AmazonCarrierForm;
}) {
  return null;
});
